import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { TypographyProps } from '@shared/ui/typography/types';
import { Typography } from '@shared/ui/typography/typography';
import { styled } from 'goober';

export const UserName = styled(Typography)`
    transition: color 0.3s ease;
`;

export const Wrapper = styled('div')<{ isShowHoverStyles?: boolean } & TypographyProps>`
    position: relative;
    display: flex;
    width: 100%;
    gap: 16px;
    border-radius: 12px;
    overflow: hidden;

    ${({ isShowHoverStyles }) => isShowHoverStyles && 'cursor: pointer;'}
    &:hover ${UserName} {
        ${({ isShowHoverStyles }) => isShowHoverStyles && `color: ${COLORS.primary_60};`}
    }
`;

export const TextWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Controls = styled('div')`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 16px;
`;

export const LoaderWrapper = styled('div')`
    position: absolute;
    display: flex;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    background-color: ${hexToRGB(COLORS.neutral_00, 0.6)};
`;
